import React from 'react';
import { ActivityIcon, RefreshCwIcon } from 'lucide-react';
interface SyncHealthViewProps {
  userPlan: string;
}
export function SyncHealthView({
  userPlan
}: SyncHealthViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-352">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-353">
        <div data-id="element-354">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-355">Sync & Health</h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-356">
            Monitor data synchronization and system health
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-357">
          <RefreshCwIcon className="w-4 h-4" data-id="element-358" />
          Run Sync
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-359">
        <ActivityIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-360" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-361">
          System Health
        </h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-362">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to access sync and health monitoring.' : 'Monitor data synchronization status and overall system health.'}
        </p>
      </div>
    </div>;
}